export default {
  'current-color': 'currentColor',
  // Main colors
  'color-primary': '#2F4D8A',
  // States
  'color-success': '#69B228',
  'color-warning': '#F7981D',
  'color-danger': '#ED1C23',
  'color-notice': '#2696E9',
  // Common
  'color-light': '#FFF',
  'color-dark': '#233146',
  // Backgrounds
  'color-bg-lightest': '#FFF',
  'color-bg-light': '#F2F7FA',
  'color-bg-medium': '#DDEDF5',
  'color-bg-medium-alt': '#EFF3F6',
  'color-bg-dark': '#233146',
  'color-bg-darkest': '#1D2531',
  // Borders
  'color-border-light': '#EBEBEB',
  'color-border': '#DEE1E4',
  // $color-border-dark: ;
  // Texts
  'color-text-lightest': '#C1CDDC',
  'color-text-light': '#7F8FA4',
  'color-text': '#333C48',
  'color-text-dark': '#000',
  'color-link': '#299EF5'
};



// WEBPACK FOOTER //
// ./src/components/helpers/sass-colors.js